import type { IComponentController } from "angular";
import type { IWeeklySchedule } from "App/Modules/Models";
import { DayTypeFunctions } from "App/Modules/Models";

export default class WeeklyScheduleComponentController implements IComponentController {
    public weeklySchedule: IWeeklySchedule;

    public groupTypeName: string;

    public dayTypes = DayTypeFunctions.WeekDaysMap();
}
